// Making a dropdown tell the truth about what is stored.
//
// A <select> whose `value` matches none of its options renders the FIRST
// option, while React state still holds the real value. The screen then says
// "Botox" for a request that is Psychological Services, and the patient edits
// something they were never shown — and if they touch anything else and save,
// what they saw was never what they had.
//
// It is not a rare case. An entry can name something the portal did not load: a
// service the clinic retired since the request was filed, or a clinician at a
// site this patient's `doctors` list does not cover.
//
// So whatever the record holds always gets an option of its own, labelled as no
// longer offered. Showing the truth and saying it is unavailable beats showing
// a convincing lie.

/**
 * @param {{value: string, label: string}[]} known   what the clinic offers now
 * @param {string} currentValue                      what the record holds
 * @param {string} fallbackLabel                     how to name it if unknown
 */
export function optionsIncludingCurrent(known, currentValue, fallbackLabel) {
  const options = Array.isArray(known) ? [...known] : [];
  if (!currentValue) return options;

  const present = options.some(
    (option) => String(option.value) === String(currentValue)
  );
  if (present) return options;

  // First, not last: it is the selected one, and a reader scanning the list
  // should meet it before the alternatives.
  options.unshift({value: String(currentValue), label: fallbackLabel});
  return options;
}
